import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
import { isLocal } from '@adsk/alloy-helpers';

function getHostnameWithoutLocal() {
  if (isLocal()) {
    // api lib returns the hostname with protocol, hostname is without protocol.
    return getAccHostname().split('//')[1];
  }

  return window.location.hostname;
}

export default getHostnameWithoutLocal;
